import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import Marketing from "@/modules/marketing/Marketing";
import AudienceList from "@/modules/marketing/audience/AudienceList";
import AudienceView from "@/modules/marketing/audience/AudienceView";
import AudienceCustomers from "@/modules/marketing/audience/AudienceCustomers";
import AudienceCampaigns from "@/modules/marketing/audience/campaign/AudienceCampaigns";
import CustomerList from "@/modules/marketing/customers/CustomerList";

const routes = [
  {
    path: 'marketing',
    name: 'marketing',
    component: Marketing,
    redirect: 'marketing/audiences',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'audiences',
        name: 'marketing.audiences',
        component: AudienceList
      },
      {
        path: 'customers',
        name: 'marketing.customers',
        component: CustomerList
      }
    ]
  },
  {
    path: 'marketing/audiences/:id',
    name: 'marketing.audience.view',
    redirect: 'marketing/audiences/:id/customers',
    component: AudienceView,
    children: [
      {
        path: 'customers',
        name: 'marketing.audience.customers',
        component: AudienceCustomers
      }, {
        path: 'campaign',
        name: 'marketing.audience.campaigns',
        component: AudienceCampaigns
      }
    ]
  }
];

MenuService.addMenuItem(new MenuItem('/marketing', i18n.t('Marketing'), 4, 'mail-bulk', [], 'view_audience'));

export {routes}
